import { makeStyles } from '@material-ui/core';

const styles = makeStyles(({ typography, breakpoints, palette }) => ({
  comoFunciona: {
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    height: 'auto',
    backgroundPosition: 'center center',
    content: '',
    textAlign: 'left',
    color: 'white',
  },
  comoFuncionaCards: {
    margin: '0 auto',
    maxWidth: '1200px',
    padding: '70px 0',
    [breakpoints.down('sm')]: {
      textAlign: 'center',
    },
  },
  comoFuncionaCardsIntern: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    '& div.ui.card': {
      margin: '10px',
      width: '200px',
      minHeight: '359px',
    },
  },
  comoFuncionaCardsInternCarrefour: {
    '& div.ui.card>.content>.header': {
      fontFamily: 'Milliard Book',
    },
    fontFamily: 'Milliard Book',
  },
  comoFuncionaCardsInternReparofone: {
    '& div.ui.card>.content>.header': {
      fontFamily: 'Milliard Book',
    },
    fontFamily: 'Roboto',
  },
  title: {
    width: '100%',
    fontSize: '3em',
    fontWeight: 100,
    padding: '0 40px',
    color: '#000000',
    textAlign: 'center',
    [breakpoints.down('sm')]: {
      fontSize: '2em',
      padding: '0 50px',
    },
  },
  titleCarrefour: {
    fontFamily: 'Milliard Book',
  },
  titleReparofone: {
    fontFamily: 'Roboto',
  },
  paragraphs: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  paragraphsCarrefour: {
    fontFamily: 'Milliard Book',
  },
  paragraphsReparofone: {
    fontFamily: 'Roboto',
  },
  infoParagraph: {
    color: '#717171',
    width: '90%',
    marginBottom: '30px',
  },
}));

export default styles;
